import Vue from 'vue'
import VueRouter from 'vue-router'
import routesExt from './router_ext'
import routesExamples from './router_examples'

Vue.use(VueRouter)

const Login = {
    template: '<div>Login</div>'
}

let routes = [
    {
        path: '/home',
        name: 'Home',
        component: () => import('@/views/Home.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/',
        name: 'Frontpage',
        component: () => import('@/views/Frontpage.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            showUserInfo: true,
            requiresAuth: true
        }
    },
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/register',
        name: 'Registrasi',
        component: () => import('@/views/Register.vue')
    },
    {
        path: '/pending-registration',
        name: 'Proses Registrasi',
        component: () => import('@/views/PendingRegistration.vue')
    },
    {
        path: '/persetujuan',
        name: 'Proses Bayar',
        component: () => import('@/views/WaitingApproval.vue'),
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/forgot-password',
        name: 'Lupa Password',
        component: () => import('@/views/ForgotPassword.vue')
    },
    {
        path: '/complete-form/:program',
        name: 'Kelengkapan Data',
        component: () => import('@/views/CompleteRegistration.vue')
    },
    {
        path: '/complete-payment',
        name: 'Pembayaran',
        component: () => import('@/views/CompletePayment.vue')
    },
    /*{
        path: '/kalender-belajar',
        name: 'Kalender Belajar',
        component: () => import('@/views/KalenderBelajar.vue')
    },*/
    {
        path: '/profile',
        name: 'User Profile',
        component: () => import('@/views/Profile.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        },
    },
    {
        path: '/about',
        name: 'Tentang Aplikasi',
        component: () => import('@/views/About.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        },
    },
    {
        path: '/berita',
        name: 'Berita',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/promosi',
        name: 'Promosi',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/promosi-detail/:id',
        name: 'Detail Promosi',
        component: () => import('@/views/Berita.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/berita',
        name: 'Berita',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/berita-detail/:id',
        name: 'Detail Berita',
        component: () => import('@/views/Berita.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/pengumuman-detail/:id',
        name: 'Detail Pengumuman',
        component: () => import('@/views/Berita.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/tanya-guru',
        name: 'Tanya Guru',
        component: () => import('@/views/TanyaGuru.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/tanya-guru-diskusi',
        name: 'Diskusi dengan Guru',
        component: () => import('@/views/Tanya.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/chat-admin',
        name: 'Chat Admin',
        component: () => import('@/views/Login.vue')
    },
    {
        path: '/materi-ajar',
        name: 'Mata Pelajaran',
        component: () => import('@/views/Materi.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/materi-ajar-content/:id',
        name: 'Materi',
        component: () => import('@/views/MateriList.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }        
    },
    {
        path: '/materi-ajar-content-detail/:id',
        name: 'Detail Materi',
        component: () => import('@/views/MateriDetail.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/soal',
        name: 'Soal Latihan',
        component: () => import('@/views/Soal.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/soal-mapel',
        name: 'Daftar Mapel Soal',
        component: () => import('@/views/SoalMapel.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/soal-mapel-list/:id/:type',
        name: 'Daftar Soal Latihan',
        component: () => import('@/views/SoalMapelList.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/soal-start',
        name: 'Info Mulai Soal',
        component: () => import('@/views/SoalStart.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }        
    },
    {
        path: '/soal-start/:id',
        name: 'Info Mulai Soal',
        component: () => import('@/views/SoalStart.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }        
    },
    {
        path: '/soal-process',
        name: 'Soal Latihan',
        component: () => import('@/views/SoalProcess.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/soal-finish',
        name: 'Soal Latihan Selesai',
        component: () => import('@/views/SoalFinish.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },

    {
        path: '/ujian',
        name: 'Ujian',
        component: () => import('@/views/Ujian.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-sprint',
        name: 'Try Out Sprint',
        component: () => import('@/views/UjianSprint.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-mapel',
        name: 'Daftar Try Out',
        component: () => import('@/views/UjianMapel.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-mapel-filter/:id',
        name: 'Daftar Try Out',
        component: () => import('@/views/UjianMapelFilter.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-mapel-type',
        name: 'Pilih Try Out',
        component: () => import('@/views/UjianMapelType.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-mapel-list/:id/:type/:jenis',
        name: 'Daftar Ujian',
        component: () => import('@/views/UjianMapelList.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-start',
        name: 'Info Mulai Ujian',
        component: () => import('@/views/UjianStart.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }        
    },
    {
        path: '/ujian-start/:id',
        name: 'Info Mulai Ujian',
        component: () => import('@/views/UjianStart.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }        
    },
    {
        path: '/ujian-start/:id/:program',
        name: 'Info Mulai Ujian',
        component: () => import('@/views/UjianStart.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }        
    },
    {
        path: '/ujian-process',
        name: 'Ujian',
        component: () => import('@/views/UjianProcess.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-process/:id',
        name: 'Ujian',
        component: () => import('@/views/UjianProcess.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-process/:id/:program',
        name: 'Ujian',
        component: () => import('@/views/UjianProcess.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-process-kecermatan/:id/:index',
        name: 'Ujian Kecermatan',
        component: () => import('@/views/UjianProcessKecermatan.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-break',
        name: 'Ujian Kecermatan Break',
        component: () => import('@/views/UjianBreak.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rekap-hasil-kecermatan',
        name: 'Ujian Kecermatan Hasil',
        component: () => import('@/views/RekapHasilKecermatan.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-process-simbol/:id',
        name: 'Tes Kecermatan Penjumlahan Simbol',
        component: () => import('@/views/UjianProcessSimbolAritmatika.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-process-simbol/:id/:col_index',
        name: 'Tes Kecermatan Penjumlahan Simbol (Per Kolom)',
        component: () => import('@/views/UjianProcessSimbolAritmatika.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rekap-hasil-simbol-aritmatika',
        name: 'Hasil Tes Kecermatan Penjumlahan Simbol',
        component: () => import('@/views/RekapHasilSimbolAritmatika.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-finish',
        name: 'Ujian Selesai',
        component: () => import('@/views/UjianFinish.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-finish/:id',
        name: 'Ujian Selesai',
        component: () => import('@/views/UjianFinish.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-finish/:id/:program',
        name: 'Ujian Selesai',
        component: () => import('@/views/UjianFinish.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian/ranking/:mapel/:id',
        name: 'Ranking List',
        component: () => import('@/views/RankingList.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor/jenis',
        name: 'Jenis Rapor Evaluasi',
        component: () => import('@/views/JenisRapor.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor',
        name: 'Rapor Evaluasi',
        component: () => import('@/views/DetailHasilUjian.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor/type',
        name: 'Tipe Rapor Evaluasi',
        component: () => import('@/views/DetailHasilUjianType.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor/type/SKD/:jenis',
        name: 'List Rapor Evaluasi SKD',
        component: () => import('@/views/DetailHasilUjianSKD.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor/type/POLRI/:jenis',
        name: 'List Rapor Evaluasi POLRI',
        component: () => import('@/views/DetailHasilUjianPOLRI.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor/type/TPA/:jenis',
        name: 'List Rapor Evaluasi TPA',
        component: () => import('@/views/DetailHasilUjianTPA.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor/type/PSIKOTES/:jenis',
        name: 'List Rapor Evaluasi Psikotes',
        component: () => import('@/views/DetailHasilUjianPSIKOTES.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor/type/SPRINT/:jenis',
        name: 'List Rapor Evaluasi Sprint',
        component: () => import('@/views/DetailHasilUjianSPRINT.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/rapor/summary-lengkap',
        name: 'Summary Lengkap',
        component: () => import('@/views/SummaryLengkap.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-trial',
        name: 'Daftar Try Out Gratis',
        component: () => import('@/views/UjianTrial.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-trial-list/:id/:type',
        name: 'Daftar Ujian',
        component: () => import('@/views/UjianTrialList.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-event',
        name: 'Daftar Try Out Event',
        component: () => import('@/views/UjianEvent.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/ujian-event-list/:id/:type',
        name: 'Daftar Ujian',
        component: () => import('@/views/UjianEventList.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    /**{
        path: '/ujian-trial',
        name: 'Try Out Gratis',
        component: () => import('@/views/UjianTrial.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },**/
    {
        path: '/pilih-paket',
        name: 'Pilih Paket',
        component: () => import('@/views/PilihPaket.vue'),
        meta: {
            layout: 'AppLayoutAdmin',
            requiresAuth: true
        }
    },
    {
        path: '/resetpass/:id',
        name: 'Reset Password',
        component: () => import('@/views/ResetPassword.vue')
    },

]

routes = routes.concat(routesExt)
routes = routes.concat(routesExamples)
const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})
router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        console.log('auth')
            console.log('record', to)
            //Vue.$root.$emit('onRouteChanged', 'new message!');
        // this route requires auth, check if logged in
        // if not, redirect to login page.
        if (!localStorage.APP_TOKEN) {
            next({ name: 'Login' })

        } 
        else {
            // get permission info from server
            setTimeout(function(){
                to.params.roles = ["create", "read", "update", "delete"];
                //record.meta.roles = record.name+Date.now();{query:{roles:record.name+Date.now()}}
                next({params:to.params}) // does not require auth, make sure to always call next()!
            }, 100);
            
        }
    } else {
        if(localStorage.APP_TOKEN && to.path === '/login'){
            //next({ path: '/' })
            next()
        } 
        else next() // does not require auth, make sure to always call next()!
    }
})
export default router
